import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {},
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1.875),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.default,
  },

  text: {
    padding: theme.spacing(0.5, 0),

    '&.MuiTypography-root': {
      display: 'list-item',
      marginLeft: theme.spacing(2.5),
    },
  },

  link: {
    fontWeight: 500,
    color: theme.palette.text.primary,
    textDecorationColor: theme.palette.text.primary,

    '&:hover': {
      color: theme.palette.text.primary,
    },
  },
}));
